module.exports = __webpack_public_path__ + "static/media/long-logo-sm.81b7fd5d.png";